import React from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Settings, Mail } from 'lucide-react';
interface MagicLinkSentScreenProps {
  email: string;
  onContinue: () => void;
  onBack: () => void;
  onSkip?: () => void;
}
export function MagicLinkSentScreen({
  email,
  onContinue,
  onBack,
  onSkip
}: MagicLinkSentScreenProps) {
  return <div className="relative w-full h-screen overflow-hidden bg-slate-900" data-id="element-92">
      {/* Background */}
      <div className="absolute inset-0 z-0" data-id="element-93">
        <img src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1920&q=80" alt="Interior background" className="w-full h-full object-cover opacity-20 blur-sm" data-id="element-94" />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-900/90 to-slate-900/70" data-id="element-95" />
      </div>

      {/* Header - Higher z-index */}
      <div className="absolute top-6 left-6 right-6 z-50 flex items-center justify-between" data-id="element-96">
        <button onClick={onBack} className="flex items-center gap-2 text-white/70 hover:text-white transition-colors" data-id="element-97">
          <ArrowLeft className="w-5 h-5" data-id="element-98" />
          <span className="text-sm" data-id="element-99">Back</span>
        </button>
        <button className="p-3 rounded-full bg-slate-800/50 backdrop-blur-sm border border-white/10 hover:bg-slate-700/50 transition-colors" data-id="element-100">
          <Settings className="w-6 h-6 text-white" data-id="element-101" />
        </button>
      </div>

      {/* Content */}
      <div className="relative z-10 flex items-center justify-center h-full" data-id="element-102">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.5
      }} className="bg-slate-800/80 backdrop-blur-xl rounded-2xl p-12 border border-white/10 shadow-2xl max-w-md w-full text-center" data-id="element-103">
          <div className="flex justify-center mb-6" data-id="element-104">
            <div className="w-16 h-16 bg-cyan-500/20 rounded-full flex items-center justify-center" data-id="element-105">
              <Mail className="w-8 h-8 text-cyan-400" data-id="element-106" />
            </div>
          </div>

          <h2 className="text-2xl text-white font-medium mb-4 uppercase tracking-wider" data-id="element-107">
            Check your inbox
          </h2>

          <p className="text-white/70 mb-8 leading-relaxed" data-id="element-108">
            We've sent a magic link to <br data-id="element-109" />
            <span className="text-white font-medium" data-id="element-110">{email}</span>
            <br data-id="element-111" />
            Click the link to sign in instantly.
          </p>

          {/* Demo button to simulate clicking the link */}
          <button onClick={onContinue} className="w-full px-8 py-3 bg-gradient-to-r from-cyan-600 to-cyan-500 hover:from-cyan-500 hover:to-cyan-400 text-white font-medium rounded-lg transition-all uppercase tracking-wider" data-id="element-112">
            Simulate Link Click
          </button>

          {onSkip && <button onClick={onSkip} className="mt-4 text-white/30 hover:text-white/60 text-sm transition-colors mx-auto block" data-id="element-113">
              Guest access →
            </button>}
        </motion.div>
      </div>
    </div>;
}